type Callback = () => void

export const gatherCallbacks = (callbacks: Callback[]) => () => callbacks.forEach(f => f.apply([]))
